// Binds a dropdown panel to a button. Can either load html on the page or fetch via ajax.
//
//
// Panels.bindPanelTo($('link'), {
//   ajaxUrl: url,               // url to fetch ajax html (optional if using panelTarget)
//   panelTarget: $('panel'),    // element to copy for panel content (optional if using ajax)
//   loaded: function() {},      // callback when ajax is finished loading
//   unhover: $('element'),      // element that when unhovered, the panel closes (must be parent)
//                               //   pass 'true' to be the panel itself (default: true)
//   align: 'left',              // 'left' or 'right'. default is 'left'
//   cssClass: 'my-panel-class'  // gets added to the panel
// });
//
// There are auto-bindings to elements with data-panel=true
// Additional data attrs as options:
//  data-panel-ajax-url
//  data-panel-target
//  data-panel-unhover
//  data-panel-align
//  data-panel-css-class
'use strict';
var Panel;

var panels = [];
var panelClass = 'panel-popout';

function hasPanelClassAncestor(element) {
  return element.closest('.' + panelClass).length > 0;
}

function closePanels() {
  $.each(panels, function (i, panel) {
    panel.close();
  });
}

Panel = function ($button, options) {
  var self = this;
  var isOpen = false;
  var $panel = $('<div />', {
    class: 'panel-popout module-shadow pointer-top',
    style: 'display: none;',
  });
  var ajaxSpinnerWait = 250; // milliseconds
  var cancelAjax = false;
  var ajaxRequest = null;

  function unhoverTarget() {
    if (options.unhover === true) {
      return $button.parent(); // wrapper contains both the button and the panel
    }

    return options.unhover;
  }

  function bindEvents() {
    $button.on('click', function (e) {
      self.handleButtonClick(e);
    });
    if (options.unhover && options.unhover !== 'false') {
      unhoverTarget().hoverIntent({
        over: function () {},
        out: self.close,
        timeout: 800,
      });
    }

    $panel.on(
      'click',
      '.panel-popout-close-action',
      function () {
        self.close();
      }
    );
  }

  function injectPanel() {
    var $wrapper = $('<div />', { class: 'panel-container' });
    $button.wrap($wrapper);

    if (options.panelTarget) {
      $panel.html(options.panelTarget.html());

      // The panel created above contains a copy of the HTML
      // from the target panel. Remove the original so there
      // is not duplication in the DOM. There is technically
      // no harm from duplication but it causes developer
      // confusion when elements are duplicated without an
      // obvious cause.
      options.panelTarget.remove();
    }

    if (options.cssClass) { $panel.addClass(options.cssClass); }

    $button.after($panel);
  }

  self.init = function () {
    injectPanel();
    bindEvents();
  };

  self.close = function () {
    $panel.hide();
    cancelAjax = true;
    isOpen = false;
    if (ajaxRequest) {
      ajaxRequest.abort();
    }
  };

  function showPanel() {
    $panel.show();
    isOpen = true;
  }

  function isProtrutedLeft() {
    var leftOffset = $button.offset().left + $button.width() - $panel.width();
    return leftOffset < 0;
  }

  function isProtrutedRight() {
    var rightOffset = $button.offset().left + $panel.width();
    return rightOffset > $(document).width();
  }

  function getAlign() {
    if (options.align === 'left') {
      if (isProtrutedRight()) {
        return 'right';
      }

      return 'left';
    }

    if (isProtrutedLeft()) {
      return 'left';
    }

    return 'right';
  }

  function alignLeftOrRight() {
    // see if our option of left or right would be position the panel past the viewport and
    // dynamically switch it
    var alignment = getAlign();

    $panel.removeClass('panel-align-left');
    $panel.removeClass('panel-align-right');
    $panel.removeClass('pointer-left');
    $panel.removeClass('pointer-right');
    $panel.addClass('panel-align-' + alignment);
    $panel.addClass('pointer-' + alignment);
  }

  function openReady() {
    alignLeftOrRight();
    showPanel();
    if (options.loaded) { options.loaded($panel); }
  }

  function ajaxDone(data) {
    if (!cancelAjax) {
      $panel.html(data);
      openReady();
    }
  }

  function spin() {
    $panel.spin();
  }

  function ajaxIsSlow() {
    if (!isOpen && !cancelAjax) {
      showPanel();
      spin();
    }
  }

  function loadAjax() {
    cancelAjax = false;
    alignLeftOrRight();
    $panel.html('');
    setTimeout(ajaxIsSlow, ajaxSpinnerWait);
    ajaxRequest = $.get(options.ajaxUrl).done(ajaxDone);
  }

  self.open = function () {
    closePanels();
    if (options.ajaxUrl) {
      loadAjax();
    } else {
      openReady();
    }
  };

  function toggleState() {
    if (isOpen) {
      self.close();
    } else {
      self.open();
    }
  }

  self.handleButtonClick = function (e) {
    e.stopPropagation();
    e.preventDefault();
    toggleState();
  };
};

function bindPanelTo($button, options) {
  var panel;
  options.align = options.align || 'left';

  if (typeof options.panelTarget === 'string') {
    options.panelTarget = $(options.panelTarget);
  }

  if (typeof options.unhover === 'string') {
    options.unhover = $(options.unhover);
  } else if (typeof options.unhover === 'undefined') {
    options.unhover = true;
  }

  panel = new Panel($button, options);
  panels.push(panel);
  panel.init();

  return panel;
}

function bindToDataAttrs() {
  $(document).on('click', '[data-panel]', function (e) {
    var options;
    var $btn = $(this);
    var panel = $btn.data('data-panel-object');
    if (!panel) {
      options = {
        ajaxUrl: $btn.data('panel-ajax-url'),
        panelTarget: $btn.data('panel-target'),
        align: $btn.data('panel-align'),
        cssClass: $btn.data('panel-css-class'),
        unhover: $btn.data('panel-unhover'),
      };
      panel = bindPanelTo($btn, options);
      $btn.data('data-panel-object', panel);
      panel.handleButtonClick(e);
    }
  });
}

function init() {
  $(document).on('click', function (e) {
    var $target = $(e.target);

    if (!hasPanelClassAncestor($target)) {
      closePanels();
    }
  });

  bindToDataAttrs();
}

module.exports = {
  init,
  bindPanelTo,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/panels.js